import {
    BUCKETS_CREATE_CANCEL,
    BUCKETS_CREATE_FAILURE,
    BUCKETS_CREATE_REQUEST,
    BUCKETS_CREATE_START,
    BUCKETS_CREATE_SUCCESS,
} from '../actions/create';
import {
    BUCKETS_LIST_ADD,
    BUCKETS_LIST_FAILURE,
    BUCKETS_LIST_REQUEST,
    BUCKETS_LIST_SUCCESS,
} from '../actions/list';
import {
    BUCKETS_REMOVE_CANCEL,
    BUCKETS_REMOVE_FAILURE,
    BUCKETS_REMOVE_REQUEST,
    BUCKETS_REMOVE_START,
    BUCKETS_REMOVE_SUCCESS,
} from '../actions/remove';
import {
    BUCKETS_TOGGLE_SELECTION,
    BUCKETS_TOGGLE_SELECTION_ALL,
} from '../actions/select';
import { StorageBucketsSelectors } from '../selectors';

const initialListState = {
    Buckets: [],
    selection: {},
    listLoading: false,
    listLoaded: false,
    listError: false,
};

const initialCreateState = {
    createOpen: false,
    createLoading: false,
    createError: '',
};

const initialRemoveState = {
    removeName: '',
    removeOpen: false,
    removeLoading: false,
};

const initialState = {
    ...initialListState,
    ...initialCreateState,
    ...initialRemoveState,
};

export default function storageBuckets(state, { type, data }) {
    if (!state) {
        return initialState;
    }

    switch (type) {
        case BUCKETS_LIST_REQUEST: {
            return {
                ...state,
                ...initialListState,
                listLoading: true,
                listLoaded: false,
            };
        }

        case BUCKETS_LIST_SUCCESS: {
            return {
                ...state,
                ...initialListState,
                listLoaded: true,
                Buckets: data.Buckets,
            };
        }

        case BUCKETS_LIST_FAILURE: {
            return {
                ...state,
                ...initialListState,
                listLoaded: false,
                listError: true,
            };
        }

        case BUCKETS_LIST_ADD: {
            return {
                ...state,
                Buckets: [...state.Buckets, data.Bucket],
            };
        }

        case BUCKETS_CREATE_START: {
            return {
                ...state,
                createOpen: true,
            };
        }

        case BUCKETS_CREATE_CANCEL:
        case BUCKETS_CREATE_SUCCESS: {
            return {
                ...state,
                ...initialCreateState,
            };
        }

        case BUCKETS_CREATE_REQUEST: {
            return {
                ...state,
                createLoading: true,
                createError: '',
            };
        }

        case BUCKETS_CREATE_FAILURE: {
            return {
                ...state,
                createLoading: false,
                createError: data.error,
            };
        }

        case BUCKETS_REMOVE_START: {
            return {
                ...state,
                ...initialRemoveState,
                removeName: data.Name,
                removeOpen: true,
            };
        }

        case BUCKETS_REMOVE_CANCEL: {
            return {
                ...state,
                ...initialRemoveState,
                removeOpen: false,
            };
        }

        case BUCKETS_REMOVE_REQUEST: {
            return {
                ...state,
                removeLoading: true,
            };
        }

        case BUCKETS_REMOVE_SUCCESS: {
            return {
                ...state,
                ...initialRemoveState,
                Buckets: state.Buckets.filter(({ Name }) => Name !== data.Name),
            };
        }

        case BUCKETS_REMOVE_FAILURE: {
            return {
                ...state,
                ...initialRemoveState,
            };
        }

        case BUCKETS_TOGGLE_SELECTION: {
            const { selection } = state;
            const { id } = data;

            return {
                ...state,
                selection: {
                    ...selection,
                    [id]: !selection[id],
                },
            };
        }

        case BUCKETS_TOGGLE_SELECTION_ALL: {
            const { Buckets } = state;
            const semiGlobalState = { storageBuckets: state };
            const all = StorageBucketsSelectors.getBucketCount(semiGlobalState);
            const selected = StorageBucketsSelectors.getSelectedBucketCount(
                semiGlobalState,
            );
            const selection = {};

            if (all !== selected) {
                for (const { Name } of Buckets) {
                    selection[Name] = true;
                }
            }

            return {
                ...state,
                selection,
            };
        }

        default:
            return state;
    }
}
